import { render, staticRenderFns } from "./ReviewAndSign.vue?vue&type=template&id=60d26c9e&"
import script from "./ReviewAndSign.vue?vue&type=script&lang=js&"
export * from "./ReviewAndSign.vue?vue&type=script&lang=js&"
import style0 from "./ReviewAndSign.vue?vue&type=style&index=0&id=60d26c9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports